import { render, staticRenderFns } from "./importadas-nfse.vue?vue&type=template&id=d1f85cd8&"
import script from "./importadas-nfse.vue?vue&type=script&lang=js&"
export * from "./importadas-nfse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports